var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carouselSection'),_c('main',{attrs:{"id":"main"}},[_c('contentSection'),_c('testimonialSection',{attrs:{"data-aos":"fade-up","data-aos-anchor-placement":"center-bottom","data-aos-delay":"150"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }